import React from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Button,
} from "@racoon/ui";
import { Namespace, useT } from "@racoon/i18n";

interface DepotChangeConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  // Name of the depot the user is switching to, shown in the warning text.
  depotName?: string;
  onConfirm: () => void;
}

// Trips solved by the optimizer all end at the same unloading point, so
// switching it invalidates the distribution. Ask before dropping it.
export const DepotChangeConfirmModal: React.FC<DepotChangeConfirmModalProps> = ({
  open,
  onOpenChange,
  depotName,
  onConfirm,
}) => {
  const t = useT();

  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <ModalContent className="max-w-lg">
        <ModalHeader>
          <ModalTitle className="text-xl font-bold">
            {t(Namespace.Routes, "depotChangeConfirmTitle")}
          </ModalTitle>
        </ModalHeader>

        <ModalBody className="py-4">
          <p className="text-sm text-text-secondary">
            {t(Namespace.Routes, "depotChangeConfirmDesc")}
          </p>
          {depotName && <p className="mt-3 text-sm font-medium text-text-primary">{depotName}</p>}
        </ModalBody>

        <ModalFooter className="rounded-b-lg border-t border-gray-100 bg-gray-50">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            {t(Namespace.Routes, "cancel")}
          </Button>
          <Button variant="opacityBlueWithOutline" onClick={onConfirm}>
            {t(Namespace.Routes, "depotChangeConfirm")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
